module.exports = __webpack_public_path__ + "static/img/headerBanner.a525b950.png";